import React, { Component } from "react";

import { NavLink } from "react-router-dom";

import { 
    home_pg_url,
    cari_home_pg_url, 
    cari_reference_url,
    cari_reference_submitted_url,
} from "../../router/static_routes";

//react prime
class HomeView extends Component {
    state = { };
    
    render() {
        return (
            <div id='container'>
                <div id='page' className="main_background">
                    <h1> Home </h1>
                    <hr/>
                    <div>
                        <ul>
                            <li>
                                <NavLink to={home_pg_url}>
                                    Home
                                </NavLink> 
                            </li>
                            <li>
                                <NavLink to={cari_home_pg_url}>
                                    Cari Home
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={cari_reference_url + "/referenceId"}>
                                    Cari Reference
                                 </NavLink>
                            </li>
                            <li>
                                <NavLink to={cari_reference_submitted_url}>
                                    Cari Reference Submitted 
                                 </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomeView;
